const { hook: globalHook } = require('js/global/module')

module.exports = ['$utils', '$q', 'Promise', 'User', '$$size', '$ionicPopup', '$translate', '$phoneModal', '$loading', '$$attachment',
  function ($utils, $q, Promise, User, $$size, $ionicPopup, $translate, $phoneModal, $loading, $$attachment) {
    /**
       * 列举邮件
       * @param params 参数object,具体查看mbox:listMessages的接口文档
       * @returns 返回查询到的结果列表
       */
    function listMessages(params) {
      const deferred = $q.defer()
      if (!params) {
        deferred.reject([])
      } else {
        Promise.wmCall('mbox:listMessages', params).then(function (data) {
          if (data.code === 'S_OK') {
            deferred.resolve(data.var)
          }
        }, function (error) {
          console.log(error)
          deferred.reject([])
        })
      }
      return deferred.promise
    }

    function uploadDirectData({ composeId, attachmentId, uid, blob, timeout, offset }) {
      const deferred = $q.defer()
      const formData = new FormData()
      formData.set('file', blob)
      const query = {
        func: 'upload:directData',
        composeId,
        attachmentId,
        offset,
        uid
      }
      User.getCurrentUser().simpleCall({
        headers: {
          'contentEncoding': 'gzip, deflate',
          'Content-Type': undefined
        },
        query,
        data: formData,
        timeout: timeout || 999999, // 上传文件接口超时时间不限制
        uploadEventHandlers: {
          progress: (event) => {
            event = event || window.event
            if (event.lengthComputable) {
              const complete = (event.loaded / event.total * 100 | 0)
              deferred.notify(complete)
            }
          }
        }
      }).then((res) => {
        deferred.resolve(res)
      }, (error) => {
        deferred.reject(error)
      })
      return deferred.promise
    }

    /// 用于维持sid不过期
    function connectServer() {
      return User.getCurrentUser().simpleCall({
        query: {
          func: 'user:getAttrs'
        },
        data: {
          attrIds: [
            'email',
            'primary_email',
            'pref_quota',
            'true_name',
            'nick_name'
          ]
        }
      })
    }

    // 打开附件预览模态框
    function openAttachPreviewModal($scope, src) {
      const extName = $scope.curAttachment.extName || $scope.curAttachment.formattype
      const size = $scope.curAttachment.estimateSize || $scope.curAttachment.size || 0
      $scope.curAttachment.filename = $scope.curAttachment.filename || $scope.curAttachment.attn || $scope.curAttachment.name
      $scope.curAttachment.previewURL = src
      if (!$$attachment.isSizeTypePreviewSupported({size: size, type: extName})) {
        const fileTypePreviewLimit = $$size.format($$attachment.getPreviewLimit(extName))
        return $ionicPopup.confirm({
          template: $translate('READ.FORBIDPREVIEW', {size: fileTypePreviewLimit}),
          cancelText: $translate.instant('OP.CANCEL'),
          cancelType: 'button-positive',
          okText: $translate.instant('OP.YES'),
          okType: 'button-default'
        })
      }

      let useDefaultAction = true
      globalHook.exec('handleAttachmentPreview', $scope.curAttachment).then(res => {
        useDefaultAction = !!res
      }).finally(_ => {
        if (!useDefaultAction) return console.log('useDefaultAction: ', useDefaultAction)// 客户定制处理

        const embededPreviewURL = $scope.curAttachment.previewURL.replace('preview.jsp', 'convert.jsp')
        $scope.attachPreviewModal = $phoneModal.fromTemplate(require('views/mail/attachPreviewModal.html'), {
          scope: $scope,
          animation: 'slide-in-up'
        })
        const destroyModel = function() {
          $scope.attachPreviewModal && $scope.attachPreviewModal.remove()
          clearInterval($scope.connectServerInterval)
        }
        $scope.closeAttachPreviewModal = function () {
          destroyModel()
        }
        // References: https://ionicframework.com/docs/v1/api/service/$ionicModal/
        $scope.$on('modal.hidden', function() {
          destroyModel()
        })
        $scope.$on('$destroy', function() {
          destroyModel()
        })
        $scope.attachPreviewModal.el.style.zIndex = 11
        $scope.attachPreviewModal.show()

        // 每隔15s连服务器一次
        connectServer()
        $scope.connectServerInterval = setInterval(function () {
          connectServer()
        }, 15000)

        const loadIframe = function(url) {
          const deferred = $q.defer()
          const iframeWrapper = document.getElementById('attachPreviewModal')
          const iframe = document.createElement('iframe')
          iframe.className = 'schedule-modal'
          iframe.frameborder = '0'
          iframe.onload = function () {
            console.log('loadIframe onload', arguments)
            deferred.resolve('S_OK')
          }
          setTimeout(() => {
            deferred.reject('Timeout!')
          }, 10 * 1000)
          iframe.src = url
          iframeWrapper.appendChild(iframe)
          return deferred.promise
        }

        $loading.show()
        $scope.openIframeFail = false
        loadIframe(embededPreviewURL).then(res => {
          console.log('openAttachPreviewModal-success', res)
          $scope.$broadcast('ATTACH_PREVIEW.CONTENT_LOADED')
        }).catch(err => {
          console.log('openAttachPreviewModal-fail', err)
          $scope.openIframeFail = true
          const iframeWrapper = document.getElementById('attachPreviewModal')
          iframeWrapper.parentNode.removeChild(iframeWrapper)
        }).finally(_ => {
          $loading.hide()
        })
      })
    }

    /**
     * 构造引文HTML
     * @param type {String} forward、reply
     * @param mail {Object}, eg: {from: [], to: [], cc: [], subject: '', sentDate: '2023-01-05 15:46:55'}
     * @returns {String} 引文HTML
     */
    function getQuoteHTMLStart(type, mail) {
      const {from = [], to = [], cc = [], sentDate, subject} = mail
      const encodeFrom = $utils.$html.encode(from.join(', '))
      const formatSentDate = $utils.$date.formatLocaleDate(sentDate)
      const encodeTo = $utils.$html.encode(to.join(', '))
      const encodeCc = $utils.$html.encode(cc.join(', '))
      const encodeSubject = $utils.$html.encode(subject)

      const getLabelHTML = (label, value) => {
        if (!value) return ''
        return `<span style="font-weight:bold;">${label}</span>${$translate.instant('MAIL.COLON')}${value}<br>`
      }
      const typeStr = {
        'forward': `<hr/><br/>${$translate.instant('COMPOSE.TIPS_FORWARD_QUOTE')}<br/>`,
        'reply': '<hr/>'
      }
      const result = (typeStr[type] || '') + `<div style="margin:20px 0px;line-height:1.5em">
        ${getLabelHTML($translate.instant('MAIL.FROM'), encodeFrom)}
        ${getLabelHTML($translate.instant('MAIL.SENT_DATE'), formatSentDate)}
        ${getLabelHTML($translate.instant('MAIL.TO'), encodeTo)}
        ${getLabelHTML($translate.instant('MAIL.CC'), encodeCc)}
        ${getLabelHTML($translate.instant('MAIL.SUBJECT'), encodeSubject)}
      </div>`
      return result
    }
    return {
      listMessages,
      connectServer,
      uploadDirectData,
      openAttachPreviewModal,
      getQuoteHTMLStart
    }
  }]



// WEBPACK FOOTER //
// ./src/js/services/globalMailService.js